import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectRepair = createSelector(selectJsonQuery, jsonQuery => getTermsValue('repair')(jsonQuery));
